import { render } from "./TabNr3.vue?vue&type=template&id=7b7c5d66&scoped=true"
import script from "./TabNr3.vue?vue&type=script&lang=js"
export * from "./TabNr3.vue?vue&type=script&lang=js"

import "./TabNr3.vue?vue&type=style&index=0&id=7b7c5d66&scoped=true&lang=css"

import exportComponent from "C:\\Users\\c1chy\\Desktop\\vue\\Vue3-Components\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b7c5d66"]])

export default __exports__